import {
  IconAutomatedTrafficFineNotificationStep2,
  IconTaxCDSNotificationStep2
} from '../assets/icons'
import taxHeaderBg from '../assets/images/tax-header-bg.png'
export const APP_THEME = {
  TTDK: 'TTDK',
  TAMOVE: 'TAMOVE',
  VIETTEL_MONEY: 'VIETTEL_MONEY',
  TAXACDS: 'TAXACDS'
}

export const APP_MODE = {
  TRAFFIC_FINE: 'TRAFFIC_FINE',
  TAX_CDS: 'TAX_CDS'
}

export const CURRENT_THEME = (process.env.REACT_APP_THEME_NAME || APP_THEME.TTDK).toUpperCase()

export const CURRENT_APP_MODE = CURRENT_THEME === APP_THEME.TAXACDS ? APP_MODE.TAX_CDS : APP_MODE.TRAFFIC_FINE

export const IS_TAX_CDS_MODE = CURRENT_APP_MODE === APP_MODE.TAX_CDS

export const TAX_CDS_PRODUCT_GROUP = {
  FREELANCE: 'FREELANCE',
  SME: 'SME',
  OFFICE: 'OFFICE'
}

export const APP_MODE_CONFIG = {
  [APP_MODE.TRAFFIC_FINE]: {
    mode: APP_MODE.TRAFFIC_FINE,

    headerClassName: '',
    headerBackgroundImage: null,
    servicePageTitle: 'Tự động thông báo phạt nguội',
    paymentTheme: CURRENT_THEME,

    servicePurposeText: 'Chọn 1 dịch vụ để tiếp tục',
    serviceCardClassName: '',
    serviceCardDescriptionClassName: '',

    stepInfoTitle: 'Thông tin phương tiện',
    StepInfoIcon: IconAutomatedTrafficFineNotificationStep2,

    paymentTitle: 'Tự động thông báo phạt nguội',
    paymentInfoLabel: 'Thông tin xe',
    paymentContentText: 'Mua gói thông báo phạt nguội',
    paymentErrorTitle: 'Thanh toán thất bại',
    paymentErrorMessages: {
      UNCONFIRMED_BOOKING_EXISTED: 'Phương tiện của quý khách đã đăng ký thông báo phạt nguội. Vui lòng kiểm tra lại!',
      CREATE_PAYMENT_FAILED: 'Tạo đơn hàng thanh toán không thành công!'
    },
    createOrderErrorFallback: 'Có lỗi xảy ra khi tạo đơn thanh toán. Vui lòng thử lại.',
    createPaymentErrorFallback: 'Có lỗi xảy ra khi thanh toán. Vui lòng thử lại.',

    showPhoneInput: true,
    showEmailModal: true,

    getServiceDescription: ({ item, customerGroup, checkDurationUsageDate }) => {
      if (customerGroup) return customerGroup
      return checkDurationUsageDate(item?.usageDate)
    },

    getServicePrice: (item) => item?.productPriceAfterVAT || 0,

    shouldShowDurationSuffix: ({ customerGroup }) => !!customerGroup,

    getPaymentVehicleDisplayValue: (vehicle) => {
      if (typeof vehicle === 'string') return vehicle
      return vehicle?.plate || vehicle?.vehiclePlate || vehicle?.vehicleIdentity || '-'
    }
  },

  [APP_MODE.TAX_CDS]: {
    mode: APP_MODE.TAX_CDS,

    headerClassName: 'HeaderPartner--tax-cds',
    headerBackgroundImage: taxHeaderBg,
    servicePageTitle: 'Trợ lý thuế thông minh',
    paymentTheme: APP_THEME.TAMOVE,

    servicePurposeText: 'Chọn 1 gói để tiếp tục',
    serviceCardClassName: 'AutomatedTrafficFineNotificationServiceCard_item--tax-cds',
    serviceCardDescriptionClassName: 'AutomatedTrafficFineNotificationServiceCard_item_description--tax-cds',

    stepInfoTitle: 'Thông tin thuế',
    StepInfoIcon: IconTaxCDSNotificationStep2,

    paymentTitle: 'Thanh toán Trợ lý thuế thông minh',
    paymentInfoLabel: 'Thông tin thuế',
    paymentContentText: 'Mua gói Trợ lý thuế thông minh',
    paymentErrorTitle: 'Thanh toán Trợ lý thuế thất bại',
    paymentErrorMessages: {
      UNCONFIRMED_BOOKING_EXISTED:
        'Mã số thuế/CCCD của quý khách đã được đăng ký gói Trợ lý thuế thông minh. Vui lòng kiểm tra lại hoặc chọn gói khác.',
      CREATE_PAYMENT_FAILED: 'Tạo đơn hàng thanh toán Trợ lý thuế thông minh không thành công!'
    },
    createOrderErrorFallback: 'Có lỗi xảy ra khi tạo đơn thanh toán Trợ lý thuế thông minh. Vui lòng thử lại.',
    createPaymentErrorFallback: 'Có lỗi xảy ra khi thanh toán Trợ lý thuế thông minh. Vui lòng thử lại.',

    showPhoneInput: true,
    showEmailModal: false,

    getServiceDescription: ({ item, checkDurationUsageDate, getProductOptionalInfo }) => {
      const optionalInfo = getProductOptionalInfo(item)
      return optionalInfo?.shortDescription || checkDurationUsageDate(item?.usageDate)
    },

    getServicePrice: (item) => item?.productPrice || 0,

    shouldShowDurationSuffix: () => true,

    getPaymentVehicleDisplayValue: (vehicle) => {
      if (typeof vehicle === 'string') return vehicle

      return {
        taxIdentity: vehicle?.taxCode || vehicle?.citizenIdentityNumber || vehicle?.plate || '-',
        taxpayerName: vehicle?.taxpayerName || '',
        address: vehicle?.businessAddress || vehicle?.taxRegistrationAddress || ''
      }
    }
  }
}

export const CURRENT_APP_MODE_CONFIG = APP_MODE_CONFIG[CURRENT_APP_MODE] || APP_MODE_CONFIG[APP_MODE.TRAFFIC_FINE]